import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { RenderSelect } from "../InputComponents/Inputs.jsx";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ADD_TO_CART_MODAL } from "../../../actions/assays.js";
import _ from "underscore";
import * as shippingTime from "../../../sampleData/shippingTimes.json";
import "./ModalAndButton.scss";
class ModalAddToCartAndQuote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSku: false,
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const { actions } = this.props;
    actions.setAssayModalType("");
    this.setState({
      selectedSku: false,
    });
  }

  //id in redux and row match, make
  handleAddToCartSubmit() {
    const {
      orderingInfo,
      uniqueRowId,
      actions,
      handleCartClicked,
      handleQuoteClicked,
      selectedSkuSize,
    } = this.props;
    const isQuote = (this.props && this.props.isQuote) || false;
    const assayDesignId = (this.props && this.props.assayDesignId) || "";
    actions.processAddAssayToCart(
      orderingInfo,
      selectedSkuSize,
      isQuote,
      uniqueRowId
    );
    !isQuote && handleCartClicked();
    isQuote && handleQuoteClicked();
    this.handleClose();
  }

  componentDidMount() {
    const {
      orderingInfo: { skuMap },
      orderingInfo,
      initialize,
    } = this.props;

    if (!_.isEmpty(skuMap) && skuMap[0].sku !== "") {
      initialize({ size: skuMap[0].sku });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedSkuSize !== this.props.selectedSkuSize) {
      this.props.blur("size", this.props.selectedSkuSize);
    }
  }

  render() {
    const ModalAddToCartAndQuoteButton = () => (
      <Button
        id="Add-to-cart-quote"
        onClick={() => this.handleAddToCartSubmit()}
        variant="contained"
        size="medium"
        color="primary"
        type="button"
      >
        {isQuote ? "Add to Quote" : "Add to Cart"}
      </Button>
    );
    const {
      modalInfo,
      orderingInfo,
      orderingInfo: { skuMap },
      selectedSkuSize,
      processingTime,
      reset,
      uniqueRowId,
    } = this.props;
    const targetType = (orderingInfo && orderingInfo.targetType) || false;
    const selectedSku =
      (selectedSkuSize && _.findWhere(skuMap, { sku: selectedSkuSize })) || "";

    const defaultProcessingTime =
      (selectedSku !== "" && _.pluck(shippingTime, selectedSkuSize)) || "";

    const isQuote = (this.props && this.props.isQuote) || false;
    const shouldModalOpen = (modalInfo, uniqueRowId) => {
      return (
        modalInfo.modalType === ADD_TO_CART_MODAL &&
        uniqueRowId === modalInfo.uniqueAssayRowId
      );
    };
    const { modalType, uniqueAssayRowId } = modalInfo;
    return (
      <Dialog open={shouldModalOpen(modalInfo, uniqueRowId)}>
        <DialogContent>
          <div className="row">
            <div className="col">
              {skuMap && _.isEmpty(skuMap) && (
                <span>
                  Internal Error: Sku map is empty for this commercial ID
                </span>
              )}
              {skuMap && !_.isEmpty(skuMap) && (
                <Field
                  name="size"
                  className="form-control"
                  component={RenderSelect}
                  label="Choose your size:"
                  defaultValue={skuMap[0].sku || ""}
                >
                  {skuMap &&
                    !_.isEmpty(skuMap) &&
                    skuMap.map((option) => {
                      if (option.size === "1000WithSeq") {
                        return (
                          <option key={option.sku} value={option.sku}>
                            1000 x 20 μl reactions + assay sequence
                          </option>
                        );
                      } else {
                        return (
                          <option key={option.sku} value={option.sku}>
                            {option.size} x 20 μl reactions
                          </option>
                        );
                      }
                    })}
                </Field>
              )}
            </div>
          </div>
          <br />
          {targetType === "HdrGenomeEdit" && (
            <div id="hdr-display-message" className="row col-auto">
              HDR Genome Edit Detection Assays must be run duplexed with an HDR
              Reference assay. Predesigned HDR Reference Assays are available
              for Human, Rat and Mouse. Please add a Predesigned HDR Reference
              Assay to your cart, or use your own reference assay.
            </div>
          )}
          <div className="row">
            <div className="col">
              <br />
              <label className="form-label">Estimated shipping time:</label>
              <br />
              {(targetType === "HdrGenomeEdit" ||
                targetType === "NhejGenomeEdit") && (
                <small>Genome Edit Detection Assays (Probe): </small>
              )}
              <small>
                {(!_.isEmpty(selectedSku) &&
                  selectedSku.processingTime &&
                  selectedSku.processingTime !== "" &&
                  selectedSku.processingTime) ||
                  (processingTime !== "" && processingTime) ||
                  (defaultProcessingTime !== "" && defaultProcessingTime) ||
                  "Up to 4 Weeks"}
              </small>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <ModalAddToCartAndQuoteButton />
          <Button
            onClick={() => {
              reset("frmModalAddToCart");
              this.handleClose();
            }}
            variant="contained"
            size="medium"
            color="default"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
const selector = formValueSelector("frmModalAddToCart");

const stateToProps = (state, props) => ({
  initialValues: {
    size:
      (props &&
        !_.isEmpty(props.orderingInfo) &&
        !_.isEmpty(props.orderingInfo.skuMap) &&
        !_.isEmpty(props.orderingInfo.skuMap[0]) &&
        !_.isEmpty(props.orderingInfo.skuMap[0].sku) &&
        props.orderingInfo.skuMap[0].sku) ||
      "",
  },
  selectedSkuSize: selector(state, "size") || "",
  processingTime:
    (props &&
      !_.isEmpty(props.orderingInfo) &&
      !_.isEmpty(props.orderingInfo.skuMap) &&
      _.findWhere(props.orderingInfo.skuMap, {
        sku: selector(props, "size"),
      })) ||
    (shippingTime[selector(props, "size")] != "" &&
      shippingTime[selector(props, "size")]),
  modalInfo: state && state.assays && state.assays.modalInfo,
});

ModalAddToCartAndQuote.propTypes = {
  orderingInfo: PropTypes.object,
  actions: PropTypes.object,
  modalInfo: PropTypes.object,
  assayDesignId: PropTypes.string,
  rowCreatedAt: PropTypes.string,
  handleCartClicked: PropTypes.func,
  handleQuoteClicked: PropTypes.func,
  isQuote: PropTypes.bool,
  initialize: PropTypes.func,
  blur: PropTypes.func,
  selectedSkuSize: PropTypes.string,
  processingTime: PropTypes.object,
};

ModalAddToCartAndQuote = reduxForm({
  form: "frmModalAddToCart",
  enableReinitialize: true,
})(ModalAddToCartAndQuote);

ModalAddToCartAndQuote = connect(stateToProps)(ModalAddToCartAndQuote);

export default ModalAddToCartAndQuote;
